module.exports = __webpack_public_path__ + "img/organizacie.a7870197.svg";